module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_7@2x-5f08308ade394be438229529b72ca30a.jpg";